import { useEffect, useState } from "react";
import { requestPayment } from "../../crud/avm.crud";
import Loader from "../../components/Loader";
import { injectIntl } from "react-intl";
const PaymentFrame = (props) => {
    const { reportHash, doPostPaymentProcess, currentUser, intl } = props
    const [iframeUrl, setIframeUrl] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        currentUser?.name && reportHash && _requestPayment()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser, reportHash])

    useEffect(() => {
        const postMessage = (e) => {
            let result = {
                status: "",
                message: ""
            }
            if (e?.data?.responseCode === 1) {
                result = {
                    status: "success",
                    message: e?.data?.responseMessage
                }
                doPostPaymentProcess(result)
            } else if (e?.data?.responseCode === 0) {
                result = {
                    status: "error",
                    message: e?.data?.responseMessage
                }
                doPostPaymentProcess(result)
            }
        }
        window.addEventListener('message', postMessage);
        return () => {
            window.removeEventListener('message', postMessage);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const _requestPayment = async () => {
        const returnErrorParam = {
            status: "warning",
            message: "Something went wrong on server!"
        }
        try {
            const postParams = {
                reportHash,
                name: currentUser.name,
                email: currentUser.email,
                phone: currentUser.phone
            };
            setLoading(true);
            const result = await requestPayment(postParams);
            const { status, data } = result.data;
            setLoading(false);
            if (status === 1) {
                setIframeUrl(data?.paymentLink)
            } else {
                result.data.errors && alert(result.data.errors);
                doPostPaymentProcess(returnErrorParam)
            }
        } catch (error) {
            setLoading(false);
            doPostPaymentProcess(returnErrorParam)
            console.log("Error", error);
        }
    };

    return (
        <div className="payment-iframe-wrapper">
            <Loader loading={loading} />
            <div className="wait-message">
                {intl.formatMessage({ id: "GENERAL.PAYMENT_FRAME_TITLE" })}
            </div>
            <div className="payment-iframe">
                {iframeUrl ? <iframe
                    id="pm-v3-consumer-avm"
                    width="100%"
                    height="100%"
                    title="AVM"
                    src={iframeUrl}
                /> : null}
            </div>
        </div>
    )
}

export default injectIntl(PaymentFrame);
